export default __webpack_public_path__ + "a29b2879ee53541c8a5071b25823938e.png";